<template>
  <v-app>
    <v-app-bar app color="primary">
      <div class="d-flex align-center">
        <v-img
          alt="Logo"
          class="shrink mr-2"
          contain
          src="https://cdn.vuetifyjs.com/images/logos/vuetify-logo-dark.png"
          width="40"
        />
        <h1 class="text-h5 white--text">Aholic's Blog</h1>
      </div>

      <v-spacer></v-spacer>

      <router-link to="/" custom v-slot="{ navigate }">
        <v-btn text @click="navigate" color="white">
          <v-icon left>mdi-home</v-icon>
          首页
        </v-btn>
      </router-link>

      <router-link :to="{ name: 'PostEdit' }" custom v-slot="{ navigate }">
        <v-btn text @click="navigate" color="white">
          <v-icon left>mdi-pencil</v-icon>
          写文章
        </v-btn>
      </router-link>

      <router-link :to="{ name: 'AboutPage' }" custom v-slot="{ navigate }">
        <v-btn text @click="navigate" color="white">
          <v-icon left>mdi-account</v-icon>
          关于我
        </v-btn>
      </router-link>
    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>

    <v-footer app color="primary" dark>
      <v-col class="text-center" cols="12">
        {{ new Date().getFullYear() }} — <strong>Aholic's Blog</strong>
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
.v-application {
  font-family: "Microsoft YaHei", sans-serif !important;
}

.v-btn {
  text-transform: none !important;
  letter-spacing: normal !important;
}
</style>
